import content from 'Content/content.json';
const {
  data: { haircolor: hairColor, skincolor: skinColor },
} = content;
const quizItem = [
  {
    className: 'hair',
    color: hairColor,
    id: 'quiz.hair_Color',
    defaultMessage: 'What is your hair color?',
  },
  {
    className: 'skin',
    color: skinColor,
    id: 'quiz.skin_color',
    defaultMessage: 'What is your skin tone color?',
  },
];

export { quizItem };
